module.exports = __webpack_public_path__ + "img/Home_Mobile_05.edc9b3fb.jpg";